import {
  FC,
  PropsWithChildren,
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

type FileInfoDrawerContextType = {
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
};

const FileInfoDrawerContext = createContext<FileInfoDrawerContextType>({
  open: false,
  onOpen: () => {},
  onClose: () => {},
});

export const FileInfoDrawerProvider: FC<PropsWithChildren> = ({ children }) => {
  const [open, setOpen] = useState(false);

  const onOpen = useCallback(() => setOpen(true), []);
  const onClose = useCallback(() => setOpen(false), []);

  const value = useMemo(
    () => ({ open, onOpen, onClose }),
    [open, onOpen, onClose]
  );

  return (
    <FileInfoDrawerContext.Provider value={value}>
      {children}
    </FileInfoDrawerContext.Provider>
  );
};

export const useFileInfoDrawerContext = () => useContext(FileInfoDrawerContext);
